import React, { useState } from "react";
import { ResponsiveImage } from "@quintype/components";
import "./donate-widget.m.css";

const DonateWidget = () => {
  const [selectedSegment, setSelectedSegment] = useState(0);

  const segmentContent = [
    {
      content: "Indian residents and organisations, 50% of donated amount can be deducted from taxable income.",
      link: "https://rzp.io/l/80Gdonations",
      img: "ncfindia/2025-05-13/9pvgzbiu/CharuduttMishra2022IndiaCommunityCREDITPrasenjeetYadav2.jpg",
      alt: "Charudutt Mishra with community members"
    },
    {
      content:
        "Indian businesses and organisations, as well as self-employed, non-salaried individuals can contribute towards scientific research.",
      link: "https://rzp.io/l/sec35",
      img:
        "ncfindia/2025-05-13/lsbsrnek/2.1-Keeping-the-corals-unharmed-remains-the-main-priority-for-our-divers-as-they-conduct-their-research-Wenzel-Pinto.jpg",
      alt: "Diver conducting coral research"
    },
    {
      content: "If you are a foreign source and would like to donate to NCF under FCRA, contact smita@ncf-india.org.",
      link: null,
      img: "ncfindia/2025-05-13/f19qvzk5/SWG-Communityengagement-Studentslearningaboutroleofnurseries.jpg",
      alt: "Students learning about nurseries"
    }
  ];

  const segmentLabels = ["SEC 80(G)", "SEC 35", "FCRA"];

  const TextContainer = () => (
    <div styleName="segment-text-container">
      <div styleName="fcra-text">
        We request your patience with the details the donation forms ask for: they are a legal requirement.
      </div>
    </div>
  );

  const cleanImageSlug = url => {
    if (!url) return "";
    return url.replace(/^https?:\/\/images\.assettype\.com\//i, "").replace(/^\//, "");
  };

  return (
    <div styleName="container" role="region" aria-label="Donation options">
      <h2 styleName="title">DONATE UNDER</h2>

      <div styleName="image-container">
        <ResponsiveImage
          slug={cleanImageSlug(segmentContent[selectedSegment].img)}
          aspect-ratio={[16, 9]}
          default-width={800}
          alt={segmentContent[selectedSegment].alt}
          sizes="(max-width: 768px) 100vw, 50vw"
          imgParams={{
            auto: "format,compress",
            q: 85
          }}
          loading="eager"
        />
      </div>

      {/* Tabs Section */}
      <div styleName="segment-container">
        {["SEC 80(G)", "SEC 35", "FCRA"].map((label, index) => (
          <div styleName="segment" key={index}>
            <div
              styleName={`segment-heading ${selectedSegment === index ? "active" : ""}`}
              onClick={() => setSelectedSegment(index)}
              role="tab"
              aria-selected={selectedSegment === index}
              aria-controls={`panel-${index}`}
              id={`tab-${index}`}
            >
              {label}
            </div>
          </div>
        ))}
      </div>

      {/* Content Section */}
      <div
        styleName="segment-body"
        role="tabpanel"
        id={`panel-${selectedSegment}`}
        aria-labelledby={`tab-${selectedSegment}`}
      >
        <div styleName="body-text">{segmentContent[selectedSegment].content}</div>

        {selectedSegment === 2 && <TextContainer />}

        {segmentContent[selectedSegment].link && (
          <div styleName="segment">
            <a
              href={segmentContent[selectedSegment].link}
              styleName="donate-tag"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button styleName="donate-button" aria-label={`Donate under ${segmentLabels[selectedSegment]}`}>
                DONATE
              </button>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default DonateWidget;
